import Vue from 'vue'
import Router from 'vue-router'
import Auth from './pages/Auth.vue'
import Main from './pages/Main.vue'
import Express from './pages/Express.vue'
import Finalize from './pages/Finalize.vue'
import Destinations from './pages/Destinations.vue'
import Profile from './pages/Profile.vue'
import Transfers from './pages/Transfers.vue'

Vue.use(Router);

let router = new Router({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    base: process.env.BASE_URL,
    routes: [{
            path: '/auth',
            name: 'Auth',
            component: Auth
        },
        {
            path: '/main',
            name: 'Main',
            component: Main
        },
        {
            path: '/express',
            name: 'Express',
            component: Express
        },
        {
            path: '/finalize',
            name: 'Finalize',
            component: Finalize
        },
        {
            path: '/destinations',
            name: 'Destinations',
            component: Destinations
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/transfers',
            name: 'Transfers',
            component: Transfers
        }
    ]
});

export default router